// extracted by mini-css-extract-plugin
export default {"formContainer":"Form_formContainer__KxjuI","title":"Form_title__8D9zY","form":"Form_form__z6j8O","input":"Form_input__KS0SB","submitButton":"Form_submitButton__jIIz8"};